import { createElement, ReactElement } from 'react';

import { AboutUs } from './AboutUs';
import { BlogHomePage } from './BlogHomePage';
import { BlogPostEndingSection } from './BlogPostEndingSection';
import { BlogPostImage } from './BlogPostImage';
import { BlogPostPage } from './BlogPostPage';
import { BlogPostSection } from './BlogPostSection';
import { Button } from './Button';
import { CardList1 } from './CardList1';
import { ComponentNotFound } from './ComponentNotFound';
import { ContentInfoCards } from './ContentInfoCards';
import { ContentTable } from './ContentTable';
import { ContentTableV2 } from './ContentTableV2';
import { Faq } from './Faq';
import { FilteredBlogPosts } from './FilteredBlogPosts';
import { Footer } from './Footer';
import { Footerv2 } from './Footerv2';
import { Global } from './Global';
import { HeaderImage } from './HeaderImage';
import { Heading } from './Heading';
import { HomePageBlogPosts } from './HomePageBlogPosts';
import { HowItWorks } from './HowItWorks';
import { HowItWorksv2 } from './HowItWorksv2';
import { HowToOpen } from './HowToOpen';
import { Leadership } from './Leadership';
import { ListIcon2 } from './ListIcon2';
import { LogoCarousel } from './LogoCarousel';
import { MediaFrame } from './MediaFrame';
import { MediaSection1 } from './MediaSection1';
import { MediaSection2 } from './MediaSection2';
import { MediaSection3 } from './MediaSection3';
import { MediaSection3v2 } from './MediaSection3v2';
import { MediaSection4 } from './MediaSection4';
import { MediaSection5 } from './MediaSection5';
import { MediaSectionBlue } from './MediaSectionBlue';
import { Navigation } from './Navigation';
import { NavigationV1 } from './NavigationV1';
import { Newsletter } from './Newsletter';
import { Numbers } from './Numbers';
import { Page } from './Page';
import { PressRecognition } from './PressRecognition';
import { ProductCards } from './ProductCards';
import { ProductCardsv2 } from './ProductCardsv2';
import { ProductComparison } from './ProductComparison';
import { ProductOfferTable } from './ProductOfferTable';
import { Review } from './Review';
import { SavingsCalculator } from './SavingsCalculator';
import { SocialBox } from './SocialBox';
import { Steps } from './Steps';
import { Stepsv2 } from './Stepsv2';
import { Subscribe } from './Subscribe';
import { Subscribev2 } from './Subscribev2';
import { TableGrid } from './TableGrid';
import { Text } from './Text';
import { TrustBar, TrustBarReference } from './TrustBar';
import { WhyRaisin } from './WhyRaisin';

export type StoryblokComponents =
  | typeof AboutUs
  | typeof CardList1
  | typeof ContentInfoCards
  | typeof Faq
  | typeof Footer
  | typeof Global
  | typeof HowItWorks
  | typeof HowToOpen
  | typeof Leadership
  | typeof MediaSection1
  | typeof MediaSection2
  | typeof MediaSection3
  | typeof MediaSection3v2
  | typeof MediaSection4
  | typeof MediaSection5
  | typeof MediaSectionBlue
  | typeof Navigation
  | typeof NavigationV1
  | typeof Numbers
  | typeof Page
  | typeof PressRecognition
  | typeof ProductCards
  | typeof ProductCardsv2
  | typeof ProductOfferTable
  | typeof ContentTable
  | typeof Review
  | typeof SocialBox
  | typeof Steps
  | typeof Subscribe
  | typeof Subscribev2
  | typeof SavingsCalculator
  | typeof Text
  | typeof WhyRaisin
  | typeof HeaderImage
  | typeof ListIcon2
  | typeof HowItWorksv2
  | typeof Stepsv2
  | typeof BlogPostPage
  | typeof BlogPostImage
  | typeof Footerv2
  | typeof ContentTableV2
  | typeof BlogPostSection
  | typeof HomePageBlogPosts
  | typeof BlogPostEndingSection
  | typeof MediaFrame
  | typeof BlogHomePage
  | typeof FilteredBlogPosts
  | typeof LogoCarousel
  | typeof TrustBar
  | typeof TrustBarReference
  | typeof TableGrid
  | typeof Button
  | typeof Heading
  | typeof ProductComparison
  | typeof Newsletter;

export const AllStoryBlokComponents: Record<string, StoryblokComponents> = {
  aboutUs: AboutUs,
  cardList1: CardList1,
  contentInfoCards: ContentInfoCards,
  faq: Faq,
  footer: Footer,
  global: Global,
  layout: Global,
  howItWorks: HowItWorks,
  howToOpen: HowToOpen,
  leadership: Leadership,
  mediaSection1: MediaSection1,
  mediaSection2: MediaSection2,
  mediaSection3: MediaSection3,
  mediaSection3v2: MediaSection3v2,
  mediaSection4: MediaSection4,
  mediaSection5: MediaSection5,
  mediaSectionBlue: MediaSectionBlue,
  navigation: Navigation,
  navigationV1: NavigationV1,
  numbers: Numbers,
  page: Page,
  pressRecognition: PressRecognition,
  productCards: ProductCards,
  productCardsv2: ProductCardsv2,
  productOfferTable: ProductOfferTable,
  contentTable: ContentTable,
  review: Review,
  socialBox: SocialBox,
  steps: Steps,
  subscribe: Subscribe,
  subscribev2: Subscribev2,
  savingsCalculator: SavingsCalculator,
  text: Text,
  whyRaisin: WhyRaisin,
  headerImage: HeaderImage,
  ListIcon2: ListIcon2,
  howItWorksv2: HowItWorksv2,
  stepsv2: Stepsv2,
  blogPostPage: BlogPostPage,
  filteredBlogPosts: FilteredBlogPosts,
  blogPostImage: BlogPostImage,
  footerv2: Footerv2,
  contentTablev2: ContentTableV2,
  blogPostSection: BlogPostSection,
  homePageBlogPosts: HomePageBlogPosts,
  blogPostEndingSection: BlogPostEndingSection,
  mediaFrame: MediaFrame,
  newBlogHomePage: BlogHomePage,
  logoCarousel: LogoCarousel,
  table: TableGrid,
  button: Button,
  heading: Heading,
  productComparison: ProductComparison,
  trustBar: TrustBar,
  trustpilot_reference: TrustBarReference,
  newsletter_reference: Newsletter,
  pressRecognition_reference: PressRecognition
};

export const Components = (type: string): StoryblokComponents => {
  const component = AllStoryBlokComponents[type] || ComponentNotFound;

  return component;
};

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const renderComponent = (props: any, type?: string): ReactElement | undefined => {
  if (type) {
    const component = Components(type);
    // eslint-disable-next-line
    // @ts-ignore
    return createElement(component, props);
  }
  return;
};
